import {creates, hoistCmp} from '@xh/hoist/core';
import {TickerTapeModel} from './TickerTapeModel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {div, filler, hbox, vbox, vspacer} from '@xh/hoist/cmp/layout';
import parse from 'html-react-parser';
import './TickerTapeBar.scss';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {popover} from '@xh/hoist/kit/blueprint';
import {select, slider} from '@xh/hoist/desktop/cmp/input';
import {exchangeStatus} from '../exchange/ExchangeStatus';
import {fmtPercent} from '@xh/hoist/format';

export const tickerTapeBar = hoistCmp.factory({
    model: creates(TickerTapeModel),
    render({model}) {
        return toolbar({
            compact: true,
            omit: !model.isEnabled,
            items: [config(), tickerTape()]
        });
    }
});

const tickerTape = hoistCmp.factory<TickerTapeModel>(({model}) => {
    if (!model.dataMarkup) return;
    if (!Number.isFinite(model.copyCount)) return;

    return div({
        className: 'marquee-strip',
        style: {fontSize: model.textSize},
        item: parse(model.dataMarkup)
    });
});

const config = hoistCmp.factory<TickerTapeModel>(({model}) =>
    hbox({
        className: 'stock-ticker__settings',
        items: [
            exchangeStatus(),
            filler(),
            popover({
                interactionKind: 'click',
                item: button({icon: Icon.gear()}),
                content: vbox({
                    className: 'stock-ticker__settings-panel',
                    items: [
                        div('Watchlist:'),
                        select({
                            bind: 'watchlistId',
                            options: model.watchlists,
                            enableFilter: false
                        }),
                        vspacer(10),
                        div('Scroll Speed:'),
                        slider({
                            bind: 'scrollSpeedFactor',
                            min: 0.0,
                            max: 2.0,
                            stepSize: 0.1,
                            labelStepSize: 0.5,
                            labelRenderer: v => fmtPercent(v, {precision: 0})
                        }),
                        vspacer(10),
                        div('Text Size:'),
                        select({
                            bind: 'textSize',
                            options: model.textSizes,
                            enableFilter: false
                        })
                    ]
                })
            })
        ]
    })
);
